import { render, staticRenderFns } from "./two-factor-auth.vue?vue&type=template&id=4e1ccc68&scoped=true"
import script from "./two-factor-auth.vue?vue&type=script&lang=js"
export * from "./two-factor-auth.vue?vue&type=script&lang=js"
import style0 from "./two-factor-auth.vue?vue&type=style&index=0&id=4e1ccc68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ccc68",
  null
  
)

export default component.exports